<style scoped>
  .selected { font-weight: bold }
  li { cursor: pointer }
</style>

<template>
  <div class="col-12 attributesBlock sizeDropBlock">
    <span class="attr-title" v-html="`${attributeGroup.attributeGroupName}`"></span>
    <button class="selectDropSize" v-on:click="visible = !visible">{{ getSelectedText || t('selection') }}
      <em class="lni lni-chevron-down"></em>
    </button>
    <div v-show="visible" class="toggleAttrsBlk">
      <ul class="attributes-list">
        <li v-for="attribute in getAttributeGroupSortedAttributes"
            :key="attribute.attributeId"
            v-on:click="setSelected(attribute.attributeId)"
            :class="getAttributeClass(attribute.attributeId)">
          {{ attribute.attributeName }}
          <span v-if="attributeUnavailable(attribute.attributeId)">({{ t('product_status.unavailable.out_of_stock') }})</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { cloneDeep, flatten } from 'lodash-es'
import store from '../../../vue/store'
export default {
  name: 'AttributeTextSelector',
  props: ['attributeGroup', 'productData'],
  data () {
    return {
      version: '0.0.2',
      visible: false,
      selected: null
    }
  },
  computed: {
    getSelectedText () {
      if (!this.selected) {
        return ''
      }
      const selected = this.attributeGroup.attributes.find(item => item.attributeId === this.selected)
      if (!selected) {
        return ''
      }
      return selected.attributeName
    },
    getAttributeIdsWithStock () {
      return flatten(this.productData.productCodes
        .filter(item => item.productStock > 0)
        .map(item => item.productCodeAttributes))
    },
    getAttributeGroupSortedAttributes () {
      //  sort based on getAttributeIdsWithStock in the end of the list
      const attributeGroup = cloneDeep(this.attributeGroup)
      return attributeGroup.attributes.sort((a, b) => {
        if (this.getAttributeIdsWithStock.includes(a.attributeId) && !this.getAttributeIdsWithStock.includes(b.attributeId)) {
          return -1
        }
        if (!this.getAttributeIdsWithStock.includes(a.attributeId) && this.getAttributeIdsWithStock.includes(b.attributeId)) {
          return 1
        }
        return 0
      })
    },
    cartContents () {
      return store.getters.cartContents
    }
  },
  mounted () {
    for (const attribute of this.attributeGroup.attributes) {
      if (!this.attributeUnavailable(attribute.attributeId)) {
        this.setSelected(attribute.attributeId)
        break
      }
    }
  },
  methods: {
    setSelected (attributeId) {
      this.selected = attributeId
      this.visible = false
      this.$emit('attribute-clicked', attributeId)
    },
    getAttributeClass (attributeId) {
      const productStockForAttributeId = this.productStockForAttributeId(attributeId)
      const productCodeId = productStockForAttributeId ? productStockForAttributeId.productCodeId : null
      const cartProductCode = this.cartContents.find(item => item.productCodeId === productCodeId)
      const cartContentQuantity = cartProductCode ? cartProductCode.quantity : 0
      if (!productStockForAttributeId || productStockForAttributeId.productStock - cartContentQuantity <= 0) {
        return 'disabled'
      }
      return this.selected === attributeId ? 'selected' : ''
    },
    productStockForAttributeId (attributeId) {
      return this.productData.productCodes.find(item => item.productCodeAttributes.includes(attributeId))
    },
    attributeUnavailable (attributeId) {
      const productStockForAttributeId = this.productStockForAttributeId(attributeId)
      const productCodeId = productStockForAttributeId ? productStockForAttributeId.productCodeId : null
      const cartProductCode = this.cartContents.find(item => item.productCodeId === productCodeId)
      const cartContentQuantity = cartProductCode ? cartProductCode.quantity : 0
      return !productStockForAttributeId || productStockForAttributeId.productStock - cartContentQuantity <= 0
    }
  }
}
</script>

<style lang="scss" scoped>
.attributesBlock {
  position: relative;
}
.toggleAttrsBlk{position:absolute; top:auto; z-index:10; background:#fff; box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; border-radius:3px; max-width:300px; left:15px; min-width:250px;
  ul{display:block; width:100%; list-style: none; margin:0; padding:0; font-size:15px;
    li{display: block; width:100%; padding-bottom:3px; padding-top:3px; color:#707070; border-bottom:1px solid #eaeaea; -webkit-transition: all 300ms ease-in-out; transition: all 300ms ease-in-out; padding-left:10px; padding-right:10px;
      &:last-child{border-bottom:0}
      &:hover{background:#eaeaea; color:var(--prime2)}
      &.disabled{
        opacity: 0.8;
        color: red;
      }
      span.similar-not-available {
        font-size: 13px
      }
    }
  }
}
.attributes-list {
  list-style-type: none;
  margin: 0;
  padding: 0.5rem;
  li {
    border-bottom: 1px solid white;
  }
}
.selectDropSize{display:block; padding-left:5px; padding-right:45px; position:relative; background:#fff; border:1px solid #eaeaea; color:#707070; border-radius:3px; padding-bottom:10px; padding-top:10px; line-height: 1;
  em{position: absolute; right:10px; top:50%; -webkit-transform: translateY(-50%); transform: translateY(-50%); font-size:12px}
}

.attributes-list {
  max-height: 185px;
  overflow: auto;
}
</style>
